import React from 'react';
import { withTheme } from 'styled-components';
import { MaterialIcon } from '@pearsontechnology/aero-components';
import {HorizontalLine, ButtonWrapper, InsertButtonIcon} from './styles';

function KnowledgeMapInsertNode({isExpanded, theme, addNodeClickHandler}){
  return (
    <HorizontalLine isExpanded={isExpanded}>
      <ButtonWrapper onClick={addNodeClickHandler}>
        <InsertButtonIcon rounded iconOnly height={30} color={theme['color.blueDark']}>
          <MaterialIcon id="add" />
        </InsertButtonIcon>
      </ButtonWrapper>
    </HorizontalLine>
  );
}

export default withTheme(KnowledgeMapInsertNode);
